import { render } from "./isi_berita.vue?vue&type=template&id=b18303a2"
import script from "./isi_berita.vue?vue&type=script&lang=js"
export * from "./isi_berita.vue?vue&type=script&lang=js"

import "./isi_berita.vue?vue&type=style&index=0&id=b18303a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__